module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý phiếu chi"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    }
  }, [_c('router-link', {
    staticClass: "text-remove-decoration text-white",
    attrs: {
      "to": {
        name: 'create-invoice'
      }
    }
  }, [_vm._v("Thêm mới")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-s-data"
    }
  }, [_c('router-link', {
    staticClass: "text-remove-decoration text-black",
    attrs: {
      "to": {
        name: 'invoice-report'
      }
    }
  }, [_vm._v("Báo cáo")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-download"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportExcel.apply(null, arguments)
      }
    }
  }, [_vm._v("Xuất excel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-download"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dialogExportZh = true
      }
    }
  }, [_vm._v("Xuất bảng kê")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.invoiceTable,
    attrs: {
      "table-name": _vm.invoiceTable,
      "data-source": "invoices",
      "data-params": _vm.filters,
      "cache-data": false,
      "data-sorts": _vm.sorts,
      "data-sorted": _vm.sorted
    },
    on: {
      "remove-filter": _vm.removeFilter,
      "filter-change": _vm.gsFilterChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          },
          on: {
            "selection-change": _vm.handleSelectionChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "align": "center",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "align": "center",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.invoiceTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.invoiceTable].current_page - 1) * _vm.dataPaginations[_vm.invoiceTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Phiếu chi",
            "width": "150"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.id))])]), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Ngày tạo"
                }
              }, [_c('span', [_vm._v(_vm._s(scope.row.created_at))])])], 1), _vm._v(" "), (scope.row.cross_check) ? _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Mã đối soát"
                }
              }, [_c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.cross_check.data.id))])])], 1) : _vm._e(), _vm._v(" "), _c('p', [_c('el-tag', {
                attrs: {
                  "size": "small",
                  "type": _vm.kindStatus(scope.row.kind)
                }
              }, [_vm._v(_vm._s(scope.row.kind_txt))])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Shop"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.client) ? _c('div', [_c('p', [_c('i', {
                staticClass: "fa fa-user"
              }), _vm._v(" " + _vm._s(scope.row.client.data.name))]), _vm._v(" "), _c('p', {
                staticClass: "click-copy"
              }, [_c('i', {
                staticClass: "fa fa-phone"
              }), _vm._v(" " + _vm._s(scope.row.client.data.phone))]), _vm._v(" "), _c('p', {
                class: {
                  'text-red': scope.row.client.data.debit_amount < 0
                }
              }, [_c('i', {
                staticClass: "fa fa-money"
              }), _vm._v(" " + _vm._s(_vm._f("vnd")(scope.row.client.data.debit_amount)))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tài khoản NH"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(!_vm.getBankInfo(scope.row.bank_info).length) ? _c('div', [_vm._v("\n                " + _vm._s(scope.row.bank_info) + "\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getBankInfo(scope.row.bank_info)), function(item, index) {
                return _c('div', {
                  key: index,
                  staticClass: "margin-bottom"
                }, [_c('span', {
                  staticClass: "click-copy"
                }, [_vm._v(_vm._s(item.value))])])
              })]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tổng tiền trả shop"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tổng phí: "), _c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.debt)))])]), _vm._v(" "), (scope.row.money_return > 0) ? _c('p', [_vm._v("Truy thu: "), _c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.money_return)))])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Thực trả: "), _c('span', {
                staticClass: "text-red click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.real_amount)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "95"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Chi tiết"
                }
              }, [_c('router-link', {
                staticClass: "text-blue padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'detail-invoice',
                    params: {
                      id: scope.row.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-search",
                attrs: {
                  "aria-hidden": "true"
                }
              })])], 1), _vm._v(" "), (!scope.row.confirmer_id) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa"
                }
              }, [_c('router-link', {
                staticClass: "text-orange padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'edit-invoice',
                    params: {
                      id: scope.row.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil-square-o",
                attrs: {
                  "aria-hidden": "true"
                }
              })])], 1) : _vm._e(), _vm._v(" "), (!scope.row.confirmer_id) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.deleteInvoice(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]) : _vm._e(), _vm._v(" "), (!scope.row.confirmer_id) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xác nhận"
                }
              }, [_c('a', {
                staticClass: "text-green padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.confirmInvoice(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-check"
              })])]) : _vm._e(), _vm._v(" "), (scope.row.can_payment) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Thanh toán"
                }
              }, [_c('a', {
                staticClass: "text-violet padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.payInvoice(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-money"
              })])]) : _vm._e(), _vm._v(" "), (scope.row.payer_id) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Gửi lại email"
                }
              }, [_c('a', {
                staticClass: "text-violet padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.sendEmail(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-envelope-o"
              })])]) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "type": "daterange",
      "range-separator": " / ",
      "format": "dd-MM-yyyy",
      "start-placeholder": "Từ ngày",
      "end-placeholder": "Đến ngày"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.filterDateRange),
      callback: function($$v) {
        _vm.filterDateRange = $$v
      },
      expression: "filterDateRange"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Ngân hàng"
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.bank_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "bank_id", $$v)
      },
      expression: "filters.bank_id"
    }
  }, _vm._l((_vm.banks), function(bank) {
    return _c('el-option', {
      key: bank.id,
      attrs: {
        "label": bank.name + ' (' + bank.short_name + ')',
        "value": bank.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Kiểu đối soát"
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.kind),
      callback: function($$v) {
        _vm.$set(_vm.filters, "kind", $$v)
      },
      expression: "filters.kind"
    }
  }, _vm._l((_vm.crossChecksHelpers.kinds), function(kindName, kindKey) {
    return _c('el-option', {
      key: kindKey,
      attrs: {
        "label": kindName,
        "value": kindKey
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('select-client', {
    attrs: {
      "placeholder": "Gõ để tìm kiếm khách hàng"
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.filters.client_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "client_id", $$v)
      },
      expression: "filters.client_id"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "margin-top",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_vm._v("\n            Tiền thanh toán:\n            "), _c('el-radio-group', {
    staticClass: "status-listting margin-lg-right",
    attrs: {
      "fill": _vm.filters.is_negative ? '#32CD32' : '#db2828'
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.is_negative),
      callback: function($$v) {
        _vm.$set(_vm.filters, "is_negative", $$v)
      },
      expression: "filters.is_negative"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_c('span', {
    class: {
      'text-red': _vm.filters.is_negative != 0
    }
  }, [_vm._v("Âm")])]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_c('span', {
    class: {
      'text-green': _vm.filters.is_negative != 1
    }
  }, [_vm._v("Dương")])])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "margin-top",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, _vm._l((_vm.statuses), function(status, index) {
    return _c('a', {
      key: index,
      staticClass: "cursor-pointer padding-all",
      class: [{
        'active-status': status.value === _vm.filters[status.key]
      }, status.class],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.setFilterStatus(status.key, status.value)
        }
      }
    }, [_vm._v(_vm._s(status.title))])
  }), 0)], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "inline-filters"
    },
    slot: "inline-filters"
  }, [(_vm.selectedRows.length > 0) ? _c('el-dropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters.is_payment < 0),
      expression: "filters.is_payment < 0"
    }],
    staticClass: "margin-right",
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleActions
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("\n            Hành động "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "disabled": _vm.filters.is_confirm == 0 ? false : true,
      "command": "confirmAll"
    }
  }, [_vm._v("Duyệt tất\n              cả")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "disabled": _vm.filters.is_confirm == 0 ? false : true,
      "command": "deleteAll"
    }
  }, [_vm._v("Xóa tất\n              cả")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "disabled": _vm.filters.is_confirm == 1 ? false : true,
      "command": "paymentAll"
    }
  }, [_vm._v("Thanh toán tất\n              cả")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "disabled": _vm.filters.is_confirm == 1 ? false : true,
      "command": "exportAll"
    }
  }, [_vm._v("Xuất\n              Excel")])], 1)], 1) : _vm._e(), _vm._v("\n        Tổng tiền cần chuyển: "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.totalMoneyNeedConfirm)))]), _vm._v("   -  \n        Tổng tiền: "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.totalMoney)))])], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Xuất bảng kê",
      "visible": _vm.dialogExportZh
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogExportZh = $event
      }
    }
  }, [_c('el-form', {
    ref: "paramsExportZhRef",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.paramsExportZh,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "200px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-radio-group', {
    staticClass: "el-form-item display-block",
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.selectedCrossCheckMode),
      callback: function($$v) {
        _vm.selectedCrossCheckMode = $$v
      },
      expression: "selectedCrossCheckMode"
    }
  }, _vm._l((_vm.crossCheckList), function(item) {
    return _c('el-radio-button', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1), _vm._v(" "), _c('el-radio-group', {
    staticClass: "el-form-item display-block",
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.selectedDateMode),
      callback: function($$v) {
        _vm.selectedDateMode = $$v
      },
      expression: "selectedDateMode"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("Theo ngày")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("Theo khoảng thời gian")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedDateMode === 1),
      expression: "selectedDateMode === 1"
    }],
    attrs: {
      "label": "Ngày tạo",
      "prop": "createdAt"
    }
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "type": "date",
      "format": "dd-MM-yyyy",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Chọn ngày"
    },
    model: {
      value: (_vm.paramsExportZh.createdAt),
      callback: function($$v) {
        _vm.$set(_vm.paramsExportZh, "createdAt", $$v)
      },
      expression: "paramsExportZh.createdAt"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedDateMode === 2),
      expression: "selectedDateMode === 2"
    }],
    attrs: {
      "label": "Ngày tạo",
      "prop": "createdAt"
    }
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "type": "daterange",
      "format": "dd-MM-yyyy",
      "value-format": "yyyy-MM-dd",
      "range-separator": " / ",
      "start-placeholder": "Từ ngày",
      "end-placeholder": "Đến ngày"
    },
    model: {
      value: (_vm.paramsExportZh.createdAtRange),
      callback: function($$v) {
        _vm.$set(_vm.paramsExportZh, "createdAtRange", $$v)
      },
      expression: "paramsExportZh.createdAtRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Chọn hãng vận chuyển",
      "prop": "carrierId"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "value": _vm.paramsExportZh.carrierId.map(function (item) { return JSON.stringify(item); }),
      "multiple": "",
      "filterable": "",
      "placeholder": "Chọn cột tương ứng"
    },
    on: {
      "change": _vm.handleChangeCarrier
    }
  }, _vm._l((_vm.carrierZhs), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": JSON.stringify(item)
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.getCrossCheckKindCod || _vm.getCrossCheckKindcompareFee) ? _c('el-form-item', {
    attrs: {
      "label": "Trạng thái"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.paramsExportZh.status),
      callback: function($$v) {
        _vm.$set(_vm.paramsExportZh, "status", $$v)
      },
      expression: "paramsExportZh.status"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "success"
    }
  }, [_vm._v("Hoàn thành")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "unsuccess"
    }
  }, [_vm._v("Chưa hoàn thành")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogExportZh = false
      }
    }
  }, [_vm._v("Hủy bỏ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitting
    },
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("Tải xuống")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e34e679"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/Invoice.vue
// module id = 638
// module chunks = 1